export default __webpack_public_path__ + "static/media/pl.bda89fae.svg";